var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('Doughnut',{attrs:{"chart-options":_vm.ruleChartOptions,"chart-data":_vm.ruleChartData,"chart-id":_vm.chartId,"plugins":_vm.ruleChartPlugins,"width":_vm.width,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }